import script from "./WebIframe.vue?vue&type=script&setup=true&lang=js"
export * from "./WebIframe.vue?vue&type=script&setup=true&lang=js"

import "./WebIframe.vue?vue&type=style&index=0&id=1c4eddb0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4eddb0"]])

export default __exports__